import * as CONSTS from './consts';
import * as JWT from 'jwt-decode';

export const ValidTokenDate = async(data) => {
    const token = JWT.jwtDecode(data);
    const nowEpoch = Math.floor(Date.now() / 1000);
    return nowEpoch < token.exp;
}

export const SimplifyToken = async(token) => {
    const simplified = JWT.jwtDecode(token);
    return simplified
}

export const GetStaffUser = async() => {
    return JSON.parse(localStorage.getItem(CONSTS.STORAGE_KEYS.STAFF_LOGIN));
}

export const GetClientUser = async() => {
    return JSON.parse(localStorage.getItem(CONSTS.STORAGE_KEYS.CLIENT_LOGIN));
}

export const GetInternalUser = async() => {
    return JSON.parse(localStorage.getItem(CONSTS.STORAGE_KEYS.INTERNAL_LOGIN));
}

export const GetGugleInfo = async() => {
    return JSON.parse(localStorage.getItem(CONSTS.STORAGE_KEYS.GUGLE_INFO));
}

export const SetGugleInfo = async(data) => {
    const final = JSON.stringify(data);
    localStorage.setItem(CONSTS.STORAGE_KEYS.GUGLE_INFO, final);
}